<div class="row mb-4">
    <label class="col-12 col-form-label text-start mb-2" translate="MATERIAL_RETURN_PICKUP_ADDRESS_LABEL"></label>
    <div class="col-12">
        <pace-core-radio-input
            class="w-100"
            [(model)]="model.deliveryReturnOptions"
            [isReadonlyInputControl]="model.isInfoSaved"
            [parentForm]="materialReturnChildren"
            (valueChange)="onAddressOptionChanged()"
        ></pace-core-radio-input>
    </div>
</div>
<div *ngIf="model.deliveryReturnOptions.selectedEntry.model.name === deliveryReturnOptions.Customer">
    <div class="row mb-3">
        <label class="col-12 col-form-label text-start" for="dropOffPointOptions"></label>
        <div class="col-12">
            <pace-core-dropdown
                id="customerAddressOptions"
                class="w-100"
                [(model)]="model.customerAddressOptions"
                [isReadonlyInputControl]="model.isInfoSaved"
                [parentForm]="materialReturnChildren"
            >
            </pace-core-dropdown>
        </div>
    </div>

    <ng-container *ngIf="model.customerAddressOptions.selectedEntry">
        <div class="row mb-3">
            <label
                class="col-md-2 col-12 col-lg-3 col-form-label text-start"
                for="txtName1"
                translate="MATERIAL_RETURN_NAME_LABEL"
            ></label>
            <div class="col-md-10 col-lg-9 col-12">
                <pace-core-text-input
                    id="txtName1"
                    class="w-100"
                    name="txtName1"
                    [(model)]="model.customerAddressOptions.selectedEntry.model.name1"
                    [parentForm]="materialReturnChildren"
                    [ariaLabel]="'MATERIAL_RETURN_NAME_LABEL' | translate"
                ></pace-core-text-input>
            </div>
        </div>

        <div class="row mb-3">
            <label class="col-md-2 col-12 col-lg-3 col-form-label text-nowrap text-start" for="txtName2"></label>
            <div class="col-md-10 col-lg-9 col-12">
                <pace-core-text-input
                    id="txtName2"
                    class="w-100"
                    name="txtName2"
                    [(model)]="model.customerAddressOptions.selectedEntry.model.name2"
                    [parentForm]="materialReturnChildren"
                ></pace-core-text-input>
            </div>
        </div>

        <div class="row mb-3">
            <label
                class="col-md-2 col-lg-3 col-12 col-form-label text-start"
                translate="MATERIAL_RETURN_STREET_LABEL"
            ></label>
            <div class="col-md-10 col-lg-9 col-12">
                <pace-core-text-input
                    class="w-100"
                    name="txtStreet"
                    [(model)]="model.customerAddressOptions.selectedEntry.model.street"
                    [parentForm]="materialReturnChildren"
                    [ariaLabel]="'MATERIAL_RETURN_STREET_LABEL' | translate"
                ></pace-core-text-input>
            </div>
        </div>
        <div class="row mb-3">
            <label
                class="col-md-2 col-lg-3 col-12 col-form-label text-nowrap text-start"
                for="txtPhone"
                translate="MATERIAL_RETURN_PHONE_LABEL"
            ></label>
            <div class="col-md-10 col-lg-9 col-12">
                <pace-core-text-input
                    id="txtPhone"
                    class="w-100"
                    name="txtPhone"
                    [(model)]="model.customerAddressOptions.selectedEntry.model.phone"
                    [parentForm]="materialReturnChildren"
                    [ariaLabel]="'MATERIAL_RETURN_PHONE_LABEL' | translate"
                ></pace-core-text-input>
            </div>
        </div>

        <div class="row mb-3">
            <label
                class="col-md-2 col-lg-3 col-12 col-form-label text-nowrap text-start"
                translate="MATERIAL_RETURN_ZIP_LABEL"
            ></label>
            <div class="col-md-10 col-lg-9 col-12">
                <pace-core-text-input
                    class="w-100"
                    name="txtPostCode"
                    [(model)]="model.customerAddressOptions.selectedEntry.model.postalCode"
                    [parentForm]="materialReturnChildren"
                    [ariaLabel]="'MATERIAL_RETURN_ZIP_LABEL' | translate"
                ></pace-core-text-input>
            </div>
        </div>
        <div class="row mb-3">
            <label
                class="col-md-2 col-lg-3 col-12 col-form-label text-nowrap text-start"
                for="txtCity"
                translate="MATERIAL_RETURN_CITY_LABEL"
            ></label>
            <div class="col-md-10 col-lg-9 col-12">
                <pace-core-text-input
                    id="dopCity"
                    class="w-100"
                    name="txtCity"
                    [(model)]="model.customerAddressOptions.selectedEntry.model.city"
                    (valueChange)="onCityChange(model.customerAddressOptions.selectedEntry.model)"
                    [parentForm]="materialReturnChildren"
                    [ariaLabel]="'MATERIAL_RETURN_CITY_LABEL' | translate"
                ></pace-core-text-input>
            </div>
        </div>
        <div class="row mb-3" *ngIf="model.enableStatesOfUSADropdown">
            <label
                class="col-md-2 col-lg-3 col-12 col-form-label text-nowrap text-start"
                for="dopState"
                translate="MATERIAL_RETURN_STATES_OF_USA_LABEL"
            ></label>
            <div class="col-md-10 col-lg-9 col-12">
                <pace-core-dropdown
                    id="dopState"
                    class="w-100"
                    name="txtState"
                    [(model)]="model.customerAddressOptions.selectedEntry.model.statesOfUSA"
                    [parentForm]="materialReturnChildren"
                ></pace-core-dropdown>
            </div>
        </div>
        <div class="row mb-3" *ngIf="displayBuilding">
            <label
                class="col-md-2 col-lg-3 col-12 col-form-label text-nowrap text-start"
                for="txtBuilding"
                translate="MATERIAL_RETURN_BUILDING_LABEL"
            ></label>
            <div class="col-md-10 col-lg-9 col-12">
                <pace-core-text-input
                    id="txtBuilding"
                    class="w-100"
                    name="txtBuilding"
                    [(model)]="model.customerAddressOptions.selectedEntry.model.building"
                    [parentForm]="materialReturnChildren"
                    [ariaLabel]="'MATERIAL_RETURN_BUILDING_LABEL' | translate"
                ></pace-core-text-input>
            </div>
        </div>
        <div class="row mb-3" *ngIf="displayFloor">
            <label
                class="col-md-2 col-lg-3 col-12 col-form-label text-nowrap text-start"
                for="txtFloor"
                translate="MATERIAL_RETURN_FLOOR_LABEL"
                *ngIf="displayFloor"
            ></label>
            <div class="col-md-10 col-lg-9 col-12" *ngIf="displayFloor">
                <pace-core-text-input
                    id="txtFloor"
                    class="w-100"
                    name="txtFloor"
                    [(model)]="model.customerAddressOptions.selectedEntry.model.floor"
                    [parentForm]="materialReturnChildren"
                    [ariaLabel]="'MATERIAL_RETURN_FLOOR_LABEL' | translate"
                ></pace-core-text-input>
            </div>
        </div>

        <div class="row mb-3">
            <label
                class="col-md-2 col-lg-3 col-12 col-form-label text-start"
                for="txtContactPerson"
                translate="MATERIAL_RETURN_CONTACT_LABEL"
            ></label>
            <div class="col-md-10 col-lg-9 col-12">
                <pace-core-text-input
                    id="txtContactPerson"
                    class="w-100"
                    name="txtContactPerson"
                    [(model)]="model.customerAddressOptions.selectedEntry.model.contactPerson"
                    [parentForm]="materialReturnChildren"
                    [ariaLabel]="'MATERIAL_RETURN_CONTACT_LABEL' | translate"
                ></pace-core-text-input>
            </div>
        </div>
        <div class="row mb-3" *ngIf="displayRoom">
            <label
                class="col-12 col-lg-3 col-md-2 col-form-label text-start"
                for="txtRoom"
                translate="MATERIAL_RETURN_ROOM_LABEL"
            ></label>
            <div class="col-md-10 col-lg-9 col-12">
                <pace-core-text-input
                    id="txtRoom"
                    class="w-100"
                    name="txtRoom"
                    [(model)]="model.customerAddressOptions.selectedEntry.model.room"
                    [parentForm]="materialReturnChildren"
                    [ariaLabel]="'MATERIAL_RETURN_ROOM_LABEL' | translate"
                ></pace-core-text-input>
            </div>
        </div>
    </ng-container>
</div>
<div *ngIf="model.deliveryReturnOptions.selectedEntry.model.name === deliveryReturnOptions.Dop">
    <div class="row mb-3">
        <label
            class="col-md-2 col-lg-3 text-nowrap col-12 col-form-label text-start"
            for="dropOffPointOptions"
            translate="MATERIAL_RETURN_DOP_NUMBER_LABEL"
        ></label>
        <div class="col-md-10 col-lg-9 col-12">
            <pace-core-dropdown
                id="dropOffPointOptions"
                class="w-100"
                [(model)]="model.dropOffPointOptions"
                [isReadonlyInputControl]="model.isInfoSaved"
                [parentForm]="materialReturnChildren"
                (valueChange)="validateForm()"
            >
            </pace-core-dropdown>
        </div>
    </div>

    <fieldset *ngIf="model.dropOffPointOptions.selectedEntry" disabled>
        <div class="row mb-3">
            <label
                class="col-md-2 col-lg-3 col-12 col-form-label text-start"
                for="dopName1"
                translate="MATERIAL_RETURN_NAME_LABEL"
            ></label>
            <div class="col-md-10 col-lg-9 col-12">
                <pace-core-text-input
                    id="dopName1"
                    class="w-100"
                    name="dopName1"
                    [(model)]="model.dropOffPointOptions.selectedEntry.model.name1"
                    [parentForm]="materialReturnChildren"
                    [ariaLabel]="'MATERIAL_RETURN_NAME_LABEL' | translate"
                ></pace-core-text-input>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-md-10 col-lg-9 col-12 offset-md-2 offset-lg-3">
                <pace-core-text-input
                    id="dopName2"
                    class="w-100"
                    name="dopName2"
                    [(model)]="model.dropOffPointOptions.selectedEntry.model.name2"
                    [parentForm]="materialReturnChildren"
                ></pace-core-text-input>
            </div>
        </div>

        <div class="row mb-3">
            <label
                class="col-md-2 col-lg-3 col-12 col-form-label text-start"
                for="dopStreet"
                translate="MATERIAL_RETURN_STREET_LABEL"
            ></label>
            <div class="col-md-10 col-lg-9 col-12">
                <pace-core-text-input
                    id="dopStreet"
                    class="w-100"
                    name="dopStreet"
                    [(model)]="model.dropOffPointOptions.selectedEntry.model.street"
                    [parentForm]="materialReturnChildren"
                    [ariaLabel]="'MATERIAL_RETURN_STREET_LABEL' | translate"
                ></pace-core-text-input>
            </div>
        </div>

        <div class="row mb-3">
            <label
                class="col-md-2 col-lg-3 col-12 col-form-label text-start"
                for="dopPostCode"
                translate="MATERIAL_RETURN_ZIP_LABEL"
            ></label>
            <div class="col-md-10 col-lg-9 col-12">
                <pace-core-text-input
                    id="dopPostCode"
                    class="w-100"
                    name="dopPostCode"
                    [(model)]="model.dropOffPointOptions.selectedEntry.model.postalCode"
                    [parentForm]="materialReturnChildren"
                    [ariaLabel]="'MATERIAL_RETURN_ZIP_LABEL' | translate"
                ></pace-core-text-input>
            </div>
        </div>

        <div class="row mb-3">
            <label
                class="col-md-2 col-lg-3 col-12 col-form-label text-start"
                for="dopCity"
                translate="MATERIAL_RETURN_CITY_LABEL"
            ></label>
            <div class="col-md-10 col-lg-9 col-12">
                <pace-core-text-input
                    id="txtCity"
                    class="w-100"
                    name="dopCity"
                    [(model)]="model.dropOffPointOptions.selectedEntry.model.city"
                    [parentForm]="materialReturnChildren"
                    [ariaLabel]="'MATERIAL_RETURN_CITY_LABEL' | translate"
                ></pace-core-text-input>
            </div>
        </div>

        <div class="row mb-3" *ngIf="model.enableStatesOfUSADropdown">
            <label
                class="col-md-2 col-lg-3 col-12 col-form-label text-start"
                for="txtState"
                translate="MATERIAL_RETURN_STATES_OF_USA_LABEL"
            ></label>
            <div class="col-md-10 col-lg-9 col-12">
                <pace-core-dropdown
                    id="txtState"
                    class="w-100"
                    name="txtState"
                    [(model)]="model.dropOffPointOptions.selectedEntry.model.statesOfUSA"
                    [parentForm]="materialReturnChildren"
                ></pace-core-dropdown>
            </div>
        </div>
    </fieldset>
</div>
<div class="row mb-3">
    <label
        class="col-md-2 col-lg-3 col-12 col-form-label text-start"
        for="txtMaterialReturnInfo"
        translate="MATERIAL_RETURN_INFO_LABEL"
    ></label>
    <div class="col-md-10 col-lg-9 col-12">
        <pace-core-text-input
            id="txtMaterialReturnInfo"
            class="w-100"
            name="txtMaterialReturnInfo"
            [(model)]="model.returnInfo"
            [parentForm]="materialReturnChildren"
            [ariaLabel]="'MATERIAL_RETURN_INFO_LABEL' | translate"
        ></pace-core-text-input>
    </div>
</div>
<div class="row mb-3">
    <div class="col-12">
        <pace-core-checkbox-input
            class="w-100"
            [(model)]="model.noPhysicalReturn"
            [isReadonlyInputControl]="model.isInfoSaved"
            [parentForm]="materialReturnChildren"
        ></pace-core-checkbox-input>
    </div>
</div>
<div *ngIf="model.isAWBPackagingEnabled" class="row my-3">
    <label
        class="col col-form-label text-start"
        for="awbPackaging"
        translate="MATERIAL_RETURN_AWB_PACKAGING_LABEL"
    ></label>
    <div class="col-12">
        <pace-core-text-input
            id="awbPackaging"
            [(model)]="model.awbPackaging"
            [parentForm]="materialReturnChildren"
            [ariaLabel]="'MATERIAL_RETURN_AWB_PACKAGING_LABEL' | translate"
        ></pace-core-text-input>
    </div>
</div>
